type Variant = Record<
  string,
  {
    id: string;
  }
>;

export interface ExperimentConfig {
  name: string;
  experimentId: number;
  variations: Variant;
}

export const CREATE_ACCOUNT_MEMBERSHIP_PAGE_EXPERIMENT_CONFIG: ExperimentConfig =
  {
    name: 'Create account membership page - password options',
    experimentId: 29338190089,

    variations: {
      variantControl: {
        id: '29376950099',
      },
      variantA: {
        id: '29361400062',
      },
    },
  };
